module.exports = __webpack_public_path__ + "static/app/img/case_item_bg.d6f4e69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/case_item_bg.jpg
// module id = wPV4
// module chunks = 1